import { DefaultRouteTabs } from '@/components/_common';
import { useDisclosure } from '@/hooks';
import { Helmet } from 'react-helmet';
import { invoiceCfeRoutePage } from '../routePageConfig';
import { PageProps } from '@/types/PageProps';
import InvoiceCFeItems from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFeItems';
import InvoiceCFEHeader from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEHeader';
import InvoiceCFEFooter from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEFooter';
import InvoiceCFEItemModal from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFeItems/CreateModal';
import { Button } from 'antd';
import { useInvoiceCFEFormContext } from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEFormProvider';
import { TaxCouponStatus } from '@/core/domain/coupon/coupons/coupons.types';
import { getActiveTabPageTaxCoupon } from '@/components/Fiscal/Invoice/InvoiceCFe/getActiveTabPageTaxCoupon';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const InvoiceCFeItensPage: React.FC<PageProps> = ({ route }) => {
  const { taxCoupon } = useInvoiceCFEFormContext();

  const disabled =
    taxCoupon?.status !== TaxCouponStatus.TYPING ||
    !hasPermissions([Authorities.FISCAL_COUPON_EDIT]);

  const [modalOpen, modalAction] = useDisclosure(false);

  return (
    <DefaultRouteTabs
      route={invoiceCfeRoutePage(route)}
      permissions={route.permissions}
      {...getActiveTabPageTaxCoupon()}
    >
      <Helmet title="Itens do cupom" />

      <InvoiceCFEHeader
        extra={
          <Button type="primary" onClick={modalAction.open} disabled={disabled}>
            Adicionar itens
          </Button>
        }
      />

      <InvoiceCFeItems />

      <InvoiceCFEItemModal open={modalOpen} onCancel={modalAction.close} />

      <InvoiceCFEFooter />
    </DefaultRouteTabs>
  );
};

export default InvoiceCFeItensPage;
